
var preact = require('preact');
var hooks = require('preact/hooks');
module.exports = {"attributes":{"viewBox":"0 0 20 20","xmlns":"http://www.w3.org/2000/svg"},"content":"<path d=\"M15.286 1H2.715c-.947 0-1.714.767-1.714 1.714v12.571A1.714 1.714 0 0 0 2.715 17h12.571c.947 0 1.714-.768 1.714-1.715V2.715C17 1.767 16.233 1 15.286 1zm.571 14.286a.572.572 0 0 1-.571.571H2.715a.572.572 0 0 1-.571-.571V2.715c0-.315.256-.571.571-.571h12.571c.315 0 .571.256.571.571v12.571zM4.554 13.244a.429.429 0 0 1 0-.606l6.97-6.97-.025-.025-3.213.012a.429.429 0 0 1-.429-.428V4.87c0-.237.192-.429.429-.429l4.857-.012c.237 0 .429.192.429.428l-.013 4.858a.429.429 0 0 1-.428.428h-.357a.429.429 0 0 1-.429-.428l.012-3.213-.025-.026-6.97 6.97a.429.429 0 0 1-.606 0l-.202-.202z\" stroke-width=\".3\" fill=\"currentColor\" stroke=\"currentColor\"/>"}
var attributes = module.exports.attributes;
var content = module.exports.content;

module.exports = function (props) {
	var ref = hooks.useRef();

	hooks.useEffect(function () {
		var div = document.createElement('div');
		div.innerHTML = '<svg>' + content + '</svg>';

		var source = div.firstChild;
		var dest = ref.current;

		while (source.firstChild) {
			dest && dest.appendChild(source.firstChild);
		}
	}, []);

	return preact.h('svg', Object.assign({ ref: ref }, attributes, props));
};
